
import { ChangeDetectorRef, Component, Input, OnChanges, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { Customer } from 'src/app/modules/customer/interfaces/customer';
import { CustomerType } from 'src/app/modules/customer/interfaces/customer-type';
import { Item } from '../../../order/interface/item';
import { ItemFormComponent } from '../item-form/item-form.component';
import { PFLEGEHILFSMITTEL_PAUSCHALE } from 'src/app/shared/constants/constants';
import { PrivateCustomer } from 'src/app/modules/private-customer/interface/private-customer';
import { Product } from 'src/app/modules/warehouse/modules/product/interfaces/product';
import { ProductGroup } from 'src/app/modules/admin/modules/product-group/interfaces/product-group';
import { ProductGroupEnum } from '../../../warehouse/modules/product/enum/product-group.enum';

@Component({
  selector: 'item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.css']
})
export class ItemListComponent implements OnChanges {

  @Input()
  customer: Customer|PrivateCustomer

  @Input()
  public products: Product[] = null;

  @Input()
  set productGroups(groups: ProductGroup[]) {
      this._productGroups = groups;
  };

  @Input()
  public items: Item[] = null;

  @Input()
  public type: string = null;

  private _productGroups = [];

  @ViewChildren(ItemFormComponent)
  public children: QueryList<ItemFormComponent> = null;

  get productGroups() {
      if (this.customer && this.customer.Type === CustomerType.INSURED_CUSTOMER) {
          return this._productGroups.filter((group: ProductGroup) => {
              return (
                  (
                    group.IsComplimentary === true
                    && group.NeedsCostPermission === false
                  )
                  || group.NeedsCostPermission === true
              );
          });
      }

      return  this._productGroups;
  }

  get showWarning(): boolean {
    let result = false
    if (!this.customer) {
      return result;
    }

    result = (this.customer.Type === CustomerType.INSURED_CUSTOMER);
    return result
  }

  constructor(public cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && this.items) {
      this.cd.detectChanges();
    }

    if (changes['customer'] && this.customer) {
      this.cd.detectChanges();
    }
  }

  public calculateSum(idProductGroup: ProductGroupEnum): number {
    let sum = 0.00;

    if (this.children === null || this.children === undefined) {
      return sum;
    }
    const itemForms = this.children.filter((child) => {
      return (child.form.valid && child.product.IdProductGroup === idProductGroup);
    });

    itemForms.forEach((item: any) => {
      sum += item.getProductPrice();
    });
    return sum;
  }

  /**
   * Gibt die Summe anhand der übergebenen Produktgruppe zurück
   * @param idProductGroup
   * @returns number
   */
  public getSum(idProductGroup: ProductGroupEnum): number {
    return this.calculateSum(idProductGroup);
  }

  /**
   * @returns Gibt die aktuell gültige Pflegehilfsmittelpauschale zurück.
   */
  public getPauschale(): number {
    return PFLEGEHILFSMITTEL_PAUSCHALE;
  }

  public getItems = () => {
    const results = [];
    this.children.map((child) => {
      const quantity = child.form.controls.Quantity.value;
      if (quantity > 0) {
        results.push(child.form.value);
      }
    });

    return results;
  }

  public getItem = (product: Product) => {
    if (this.items !== null) {
      return this.items.find((item) => {
        return item.IdProduct === product.Id;
      });
    }
    return null;
  }

  /**
   * Überprüft ob die Brutto-Summe der Produktgruppe 54 unterhalb der Freibetragsgrenze liegt
   *
   * @param idProductGroup
   * @return boolean
   */
  public checkSum = (idProductGroup: ProductGroupEnum) => {
    if (idProductGroup === 2) {
      return (this.calculateSum(idProductGroup) <= PFLEGEHILFSMITTEL_PAUSCHALE);
    }

    return true;
  }

  /**
   * Gibt die Klasse für die Zeile mit der Gesamtsumme zurück
   */
  public getClass = (idProductGroup: ProductGroupEnum) => {
    if (!this.checkSum(idProductGroup) && this.showWarning) {
      return 'nb-form-warning';
    }

    return '';
  }

  public getProductByGroup = (idProductGroup: ProductGroupEnum) => {
    if (this.products !== undefined) {
      return this.products.filter((product) => {
        return (product.IdProductGroup === idProductGroup);
      });
    }

    return [];
  }

  public update = ($event) => {
    if ($event) {
      this.cd.detectChanges();
    }
  }

  isValid = (): boolean => {
    let results = this.children.map((item: ItemFormComponent) => {
      return item.form.valid;
    });

    return results.reduce((a: boolean, b: boolean) => {
      return (a && b);
    });
  }
}
